var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVoiceControl24 = function SvgVoiceControl24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.002 2h-.004C9.79 2 8 3.528 8 5.414v5.172C8 12.472 9.79 14 11.998 14h.004C14.21 14 16 12.472 16 10.586V5.414C16 3.528 14.21 2 12.002 2Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 11c0 1.857-.843 3.637-2.344 4.95-1.5 1.313-3.535 2.05-5.658 2.05-2.121 0-4.156-.739-5.656-2.051C4.842 14.636 4 12.856 4 11",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 9h3M9 22h6m-3-3v3M9 6h3",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
};
export default SvgVoiceControl24;